import { useCallback, useEffect, useState } from 'react';

import { extractTrendUiErrorMessage } from '../errorUtils';
import { fetchTrendOpportunities } from '../service';
import type { TrendOpportunity } from '../types';

export function useTrendsOpportunities(type?: string) {
  const [opportunities, setOpportunities] = useState<TrendOpportunity[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      setOpportunities(await fetchTrendOpportunities(type));
    } catch (err: any) {
      setError(extractTrendUiErrorMessage(err, 'Kunde inte ladda möjligheter.'));
    } finally {
      setLoading(false);
    }
  }, [type]);

  useEffect(() => {
    void reload();
  }, [reload]);

  return { opportunities, loading, error, reload, setOpportunities };
}
